import { createModelSelector, createSelector } from '@ngxs/store';
import { BusinessState } from '@state/business';
import { EmailTemplatesSelectors } from '@state/email-templates/email-templates.selectors';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterClients } from '@state/global/matter_clients';

export class EmailTemplatesDrawerSelectors {
	static $formattedSelectedTemplate = createSelector(
		[EmailTemplatesSelectors.$selectedEmailTemplate],
		(selectedTemplate) => {
			return {
				...selectedTemplate?.version,
				id: selectedTemplate?.metadata?.id,
			};
		},
	);

	static $clientEmailOptions = createSelector(
		[MatterClients.get],
		(clients) => {
			const emails = clients
				.map((c) => c.email)
				.filter((email) => email && email.trim() !== '')
				.filter((email, index, self) => self.indexOf(email) === index); // Remove duplicates

			return emails.map((email) => ({
				text: email,
				id: email,
			}));
		},
	);
}

export const emailTemplatesDrawerViewModel = createModelSelector({
	tagOptions: TagsSelector.$emailTemplateTagOptions,
	selectedTemplate: EmailTemplatesDrawerSelectors.$formattedSelectedTemplate,
	businessId: BusinessState.businessId,
	matterId: SelectedMatter.id,
	clientEmailOptions: EmailTemplatesDrawerSelectors.$clientEmailOptions,
});
